import { ConfigState } from '../../../models';
import { CONFIG_MUTATIONS_KEYS } from '../config.const';
import { ConfigMutation } from '../config.interfaces';

export class SetLocaleMutation implements ConfigMutation {
  mutations = {
    [CONFIG_MUTATIONS_KEYS.setLocale]: (config: ConfigState, localeCode: string) => {
      config.dynamic.lang = localeCode;
    },
    [CONFIG_MUTATIONS_KEYS.setSearchLocale]: (config: ConfigState, localeCode: string) => {
      config.dynamic.searchLang = localeCode;
    }
  };
}
